import { render, staticRenderFns } from "./PauseButton.vue?vue&type=template&id=78a707f8&"
import script from "./PauseButton.vue?vue&type=script&lang=ts&"
export * from "./PauseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports